import { render } from "./ResponsesTableMini.vue?vue&type=template&id=617c46f6"
import script from "./ResponsesTableMini.vue?vue&type=script&lang=js"
export * from "./ResponsesTableMini.vue?vue&type=script&lang=js"

import "./ResponsesTableMini.vue?vue&type=style&index=0&id=617c46f6&lang=scss"
script.render = render

export default script